import React, { useEffect, useState } from 'react';
import {
  Route,
  withRouter
} from 'react-router-dom';

import { SessionContext } from '../../utils/context';
import AccessDenied from './accessDenied';

function PrivateRoute({  role, component: Component, ...rest }) {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const sessionInfo = sessionStorage.getItem('sessionInfo');
    // si existeix miram si l'usuari està autoritzat
    if (sessionInfo) {
      // el storage del navegador només treballa amb string, ho convertesc en un objecte JSON per poder manipular-lo
      const sessionInfoObj = JSON.parse(sessionInfo);
      // consideram que el token ja no és vàlid si caduca d'aquí a 5 segons, per evitar que pugui caducar
      // en el moment de fer la consulta a la BDD per sol.licitar les dades per carregar la següent pàgina
      const isValid = sessionInfoObj.tokenExp * 1000 > (Date.now() + 5000);
      isValid && sessionInfoObj.role === role && setIsAuthorized(true); // A part de que el token sigui vàlid el rol de la sessió ha de coincidir amb el de la ruta      
    }
    setIsReady(true); // Per evitar que es mostri un instant AccessDenied quan encara no s'ha comprovat si l'usuari està autoritzat
  }, []);

  return (
    <Route {...rest} render={(props) => (
      isAuthorized ? <Component {...props} />
      : <AccessDenied showContent={isReady} />
    )} />    
  );
}

export default withRouter(PrivateRoute);